import { useLayoutEffect, useEffect } from "react";
import { isClient } from "../global";

// Use useEffect for SSR first render pass to suppress warning when using
// useLayoutEffect on the server: https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
export const useIsomorphicLayoutEffect = isClient()
  ? useLayoutEffect
  : useEffect;

export default useIsomorphicLayoutEffect;
